export const SERVER_URL = 'https://backend.nextblock.io';
